import React from "react";
import PropTypes from "prop-types";
import { Field } from "formik";

const FormikLeftAlignedCheckbox = ({ name, label, disabled }) => (
  <span>
    <label
      style={{
        cursor: disabled ? "default" : "pointer",
        fontSize: "1.15em",
        display: "inline-flex",
        paddingRight: 20
      }}
    >
      <Field
        type="checkbox"
        name={name}
        disabled={disabled}
        style={{ margin: "0px 10px 0px 0px" }}
      />
      {label}
    </label>
  </span>
);

FormikLeftAlignedCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  disabled: PropTypes.bool
};

export default FormikLeftAlignedCheckbox;
